import { inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
  const embedComponents = document.querySelectorAll('.component-embed__embed');

  if (embedComponents.length === 0) return;

  embedComponents.forEach((embed) => {
    const cover = embed.querySelector('.embed-cover');
    const iframe = embed.querySelector('.video-iframe');

    if (!iframe || !cover) return;

    // When the embed scrolls into view, attach the autoplay src
    inView(embed, () => {
      const originalSrc = iframe.src;
      const autoplayParam = originalSrc.includes('?') ? '&play=1' : '?play=1';
      iframe.src = originalSrc + autoplayParam;
    }, {
      amount: 0.2,
      once: true
    });

    // Hide the cover and start playback on click
    cover.addEventListener('click', () => {
      cover.style.display = 'none';
      // If the iframe hasn't already begun loading with autoplay, ensure it does now:
      if (!iframe.src.includes('play=1')) {
        const originalSrc = iframe.src;
        const autoplayParam = originalSrc.includes('?') ? '&play=1' : '?play=1';
        iframe.src = originalSrc + autoplayParam;
      }
    });
  });
});
